<template>
  <div class="quote-board-page">
    <iframe
      ref="boardFrame"
      :src="boardSrc"
      frameborder="0"
      allowfullscreen
      class="board-iframe"
      @load="onFrameLoad"
    ></iframe>
  </div>
</template>

<script>
// 版本号：每次更新 quote-board.html 时递增，强制 iframe 绕过浏览器缓存加载最新版
const BOARD_VERSION = '20260814c';
export default {
  name: 'QuoteBoard',
  data() {
    return {
      boardSrc: '/quote-board.html?v=' + BOARD_VERSION
    }
  },
  methods: {
    onFrameLoad() {
      // 通过 postMessage 向 iframe 传递 accessToken，避免 sessionStorage 跨 iframe 访问限制
      try {
        const token = sessionStorage.getItem('accessToken');
        if (token && this.$refs.boardFrame && this.$refs.boardFrame.contentWindow) {
          this.$refs.boardFrame.contentWindow.postMessage({ type: 'im-auth', token: token }, '*');
        }
      } catch (e) {
        console.warn('[行情看板] 传递认证信息失败:', e);
      }
    }
  }
}
</script>

<style scoped>
.quote-board-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.board-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
